/* eslint-disable no-useless-constructor */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeviceSelection from './index';
import GridWallComponent from './gridWall';



class MainComponent extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {
          this.props.unAuthflow ? <GridWallComponent {...this.props} /> : <DeviceSelection {...this.props} />
        }
      </div>
    );
  }
}

MainComponent.propTypes = {
  unAuthflow: PropTypes.bool,
};
export default MainComponent;

